// eslint-disable-next-line import/prefer-default-export
export const FEATURE_FLAGS = {
  EXPENSE_TRACKER: 'expense_tracker',
  API_INTEGRATIONS: 'api_integrations',
  LEAD_MANAGEMENT: 'lead_management',
  TALLY_INTEGRATION: 'tally_integration',
  GST: 'gst',
  EVENTS: 'events',
  FORMS: 'forms',
  CUSTOM_TERM: 'custom_term',
  CLONE_GROUP: 'clone_group',
  MANUAL_PAYMENT_BANK_ACCOUNT_MAPPING: 'manual_payment_bank_account_mapping',
  ATTENDANCE_EXEMPT: 'attendance_exempt',
  LEAD_SQUARED: 'leadsquared_integration',
  MEMBER_END_DATE: 'member_end_date',
  AUTO_DEBIT: 'auto_debit',
  EVENT_SUBTICKETS: 'event_subtickets',
  EVENT_COUPONS: 'event_coupons',
  CLONE_EVENT: 'clone_event',
  GROUP_MEMBERS_DEFAULT_FILTER_ALL: 'group_members_default_filter_all',
  INTRO_MESSAGE_SHARE_WITH_INACTIVATION:
    'intro_message_share_with_inactivation',
  INTRO_MESSAGE_SHARE: 'intro_message_share',
  CUSTOM_NOTIFICATION_PROVIDER: 'custom_notification_provider',
  DAILY_CASH: 'daily_cash',
  PAYMENT_ORDER_DISCOUNT: 'payment_order_discount',
  MULTI_CURRENCY_SUPPORT: 'multi_currency_support',
  RESTRICT_DISABLE_PAYMENT_ORDER: 'restrict_disable_payment_order',
  ATTENDANCE_BASED_FEE_COLLECTION: 'attendance_based_fee_collection',
  META_LEAD_INGESTION: 'lead_ingestion',
  MASK_GROUP_FINANCIAL_SUMMARY: 'mask_group_financial_summary',
  DEMO_MODE: 'demo_mode',
  CHARGES_REPORT: 'charges_report',
  SYNC_GROUP_UPDATE_TO_MEMBERS: 'sync_group_update_to_members'
};
